import { initializeApp } from './utils/initializeApp'
import App from './App.vue'

window.createMainApp = () => initializeApp(App, '#het-geluid-main')
window.createMainApp()
